/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import {
  useState,
  useCallback,
} from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Link } from 'react-router-dom'

import { Button } from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'cookie-banner'

/**
 * This is the component description.
 */
const CookieBanner = ({
  id,
  className:userClassName,
  style,
  onAccept:userOnAccept,
  onDeny:userOnDeny,
  readMoreLink,
  description,
  // ...otherProps
}) => {
  const isClient = typeof window !== 'undefined'

  const cookieAcceptance = isClient ? localStorage.getItem('paretoConsent') : true

  const [isShowing, setIsShowing] = useState(!cookieAcceptance)

  function gtag(...args) {
    if (isClient) {
      window.datalayer = window.datalayer || []
      window.datalayer.push(...args)
    }
  }

  const onAccept = useCallback(() => {
    userOnAccept?.()
    if (isClient) {
      const consent = {
        ad_storage        :'granted',
        analytics_storage :'granted',
        ad_user_data      :'granted',
        ad_personalization:'granted',
      }
      gtag('consent', 'update', consent)
      localStorage.setItem('paretoConsent', JSON.stringify(consent))
    }
    setIsShowing(false)
  }, [])

  const onDeny = useCallback(() => {
    userOnDeny?.()
    setIsShowing(false)
  }, [])

  if (isShowing) {
    return (
      <div
        id={id}
        className={[
          baseClassName,
          componentClassName,
          userClassName,
          'grid',
        ]
          .filter((e) => e)
          .join(' ')}
        style={style}
      >
        <div className="description md-start-2 md-span-8 span-6">
          <p>
            {description}
            &nbsp;
            {readMoreLink
          && (
          <Link
            className="link"
            to={readMoreLink}
          >
            <Button
              isSimple
              color="paragraph"
            >
              Read more
            </Button>
          </Link>
          )}
          </p>
        </div>
        <div className="actions md-start-12 md-span-2 span-2">
          <Button
            onClick={onDeny}
            className="deny"
            color="background-far"
            isCompact
          >
            Deny
          </Button>
          <Button
            onClick={onAccept}
            color="interactive"
            className="accept"
            isCompact
            isGradient
          >
            Accept
          </Button>
        </div>
      </div>
    )
  }
  return null
}

CookieBanner.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   * the function that will be executed when clicked on deny
   */
  onDeny:PropTypes.func,

  /**
   * the function that will be executed when clicked on the accept
   */
  onAccept:PropTypes.func,

  /**
   * description of the pop up for the cookie banner
   */
  description:PropTypes.string.isRequired,

  /**
   * read more link to access the more detailed version of cookie policy
   */
  readMoreLink:PropTypes.string,
}

CookieBanner.defaultProps = {
  //
}

export default CookieBanner
